import type { TierRank } from '../game/types';
import { str } from './strings';

/**
 * Stored results keep the tier emoji — it is the share's medal, and the share
 * is the one place emoji belong (STYLEGUIDE §6). Inside the interface the rank
 * is a word instead, and the words are copy: they live in the dictionaries
 * with everything else the player reads, and this module is the seam between
 * the medal a result was filed under and the word it reads as today.
 */
const RANK_OF: Record<string, TierRank> = {
  '🏆': 'superconductor',
  '🥇': 'master',
  '🥈': 'journeyman',
  '🥉': 'apprentice',
};

/** The tier ladder's top rung, as stored. */
export const PERFECT_TIER = '🏆';

/** The rank a stored tier reads as, or `''` for one this build doesn't know. */
export function rankName(tier: string | undefined): string {
  const rank = tier ? RANK_OF[tier] : undefined;
  return rank ? str().ranks[rank] : '';
}

/**
 * The stable key a stored tier stands for, or `undefined` for one this build
 * doesn't know. The usage stream files results under this, never under a word
 * (`backend/events.schema.json` pins the set), so it must not translate.
 */
export function rankKey(tier: string | undefined): TierRank | undefined {
  return tier ? RANK_OF[tier] : undefined;
}
